import api from "utils/api";

export default function useSubscribeToOffers() {
  const unsubscribeFromOffers = async (firebaseToken, profileId) => {
    try {
      const result = await api.unsubscribeFromOffers(firebaseToken, {
        profileId: profileId,
      });
      return result.data;
    } catch (error) {
      console.error("Failed to unsubscribe from offers:", error);
      throw error;
    }
  };

  return { unsubscribeFromOffers };
}
